<template>
  <div class="container mt-3">
    <div class="row">
      <div class="col s12">
        <transition
          appear
          name="component-fade"
          mode="out-in"
        >
          <div v-if="redirectToGateway" key="redirect" class="card blue-grey lighten-2 white-text">
            <div class="card-content valign-wrapper" style="min-height:400px;">
              <div class="center-align" style="width:100%;">
                <div class="saving-animation">
                  <div class="lds-ripple">
                    <div></div>
                    <div></div>
                  </div>
                </div><br>

                Re-directing to our secure payment gateway partner...
              </div>
            </div>
          </div>

          <div v-if="offlinePayment" key="offline" class="card blue-grey lighten-2 white-text">
            <div class="card-title blue-grey darken-1">
              You're almost done!
            </div>

            <div class="card-content valign-wrapper" style="min-height:400px;">
              <div class="center-align" style="width:100%;">
                Thank you for filling up the subscription form.<br>
                You have chosen to pay offline.<br>
                We will contact you soon to complete this transaction.<br>
                Message us on 9826612456 for any queries!
              </div>
            </div>
          </div>

          <div v-if="!redirectToGateway && !offlinePayment" key="form" class="card">
            <div class="card-title primary white-text">
              <i class="material-icons icon">card_membership</i>
              Subscription summary
            </div>

            <div class="card-content">
              <div class="row details-content mb-0">
                <div class="col s12 mb-1">
                  <div class="card">
                    <div class="card-title blue-grey lighten-5">
                      <b>Contact details</b>
                    </div>

                    <div v-if="loadingAnimation" class="card-content valign-wrapper center-align">
                      <LoadingCircle/>
                    </div>

                    <div v-if="!loadingAnimation" class="card-content">
                      <div class="row">
                        <div class="col s12 m3">
                          Name:
                        </div>
                        <div class="col s12 m9">
                          {{ subscribe.name }}
                        </div>

                        <div class="col s12 m3">
                          Email:
                        </div>
                        <div class="col s12 m9">
                          {{ subscribe.email }}
                        </div>

                        <div class="col s12 m3">
                          Phone:
                        </div>
                        <div class="col s12 m9">
                          {{ subscribe.phone }}<br>
                        </div>

                        <div class="col s12 m3">
                          Delivery City:
                        </div>
                        <div class="col s12 m9">
                          {{ subscribe.city }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col s12 mb-1">
                  <div class="card">
                    <div class="card-title blue-grey lighten-5">
                      <b>Subscription Details</b>
                      <a @click="changePlan" class="right btn btn-flat blue-grey lighten-4" style="height:26px;line-height:26px;font-size:11px;">
                        CHANGE PLAN
                      </a>
                      <div class="clearfix"></div>
                    </div>

                    <div v-if="loadingAnimation" class="card-content valign-wrapper center-align">
                      <LoadingCircle/>
                    </div>

                    <div v-if="!loadingAnimation" class="card-content">
                      <table>
                        <thead>
                          <tr>
                            <th>
                              Details
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <div class="row">
                                <div class="col s12 m12 xl3">
                                  <b>
                                    {{ subscriptionDetails.planTitle }}
                                  </b>
                                </div>

                                <div class="col s12 m4 xl3">
                                  {{ formatAmount(subscriptionDetails.rate) }} / month
                                </div>

                                <div class="col s12 m4 xl3 title-align">
                                  x {{ subscriptionDetails.duration }} months
                                </div>

                                <div class="col s12 m4 xl3 right-align">
                                  {{ formatAmount(planTotal) }}
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td style="padding-bottom:0;padding-top:0;">
                              <div class="row" style="margin-top:20px; margin-bottom:20px;">
                                <div class="col s12 m8 xl9 title-align">
                                  <transition
                                    appear
                                    name="component-fade"
                                    mode="out-in"
                                  >
                                    <div v-if="!showCouponField" key="q">
                                      <span v-if="discountAmount > 0">{{ couponTitle }}</span>
                                      <a v-else @click="showCouponField = true">{{ couponTitle }}</a>

                                      <div v-if="discountAmount > 0" style="line-height:1rem;">
                                        <a @click="removeCoupon" style="font-size:10px;">Change / Remove</a>
                                      </div>
                                    </div>
                                    <div v-else key="a" class="input-container">
                                      <div class="input-field mt-0 mb-0" style="max-width:200px;">
                                        <a @click="removeCoupon" class="suffix" style="top:0.2rem;">
                                          <i class="material-icons grey-text text-lighten-1" style="font-size:1.5rem;">clear</i>
                                        </a>
                                        <input
                                          type="text"
                                          id="coupon"
                                          class="mb-0"
                                          style="text-align:left;"
                                          v-model="couponCode"
                                        >
                                        <label for="coupon">Enter Coupon Code</label>
                                        <span class="helper-text red-text">{{ (formErrorsCouponCode !== '') ? formErrorsCouponCode : '' }}</span>
                                      </div>
                                    </div>
                                  </transition>
                                </div>

                                <div class="col s12 m4 xl3 right-align">
                                  <span v-if="discountAmount > 0">
                                    {{ '-' + formatAmount(discountAmount) }}
                                  </span>
                                  <span v-else>
                                    <a v-if="showCouponField && couponCode !== ''" @click="validateCoupon" class="validate-button waves-effect">Validate</a>
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr v-show="subscriptionDetails.shippingRate > 0">
                            <td>
                              <div class="row">
                                <div class="col s12 m12 xl3">
                                  Shipping:
                                </div>

                                <div class="col s12 m4 xl3">
                                  {{ formatAmount(subscriptionDetails.shippingRate) }} / month
                                </div>

                                <div class="col s12 m4 xl3 title-align">
                                  x {{ subscriptionDetails.duration }} months
                                </div>

                                <div class="col s12 m4 xl3 right-align">
                                  {{ formatAmount(shippingTotal) }}
                                </div>
                              </div>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <div class="row">
                                <div class="col s12 m8 xl9 title-align">
                                  <b>Total</b>
                                </div>

                                <div class="col s12 m4 xl3 right-align">
                                  <b>INR {{ formatAmount(grandTotal) }}</b>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div v-if="isGift" class="col s12 mb-1">
                  <div class="card">
                    <div class="card-title blue-grey lighten-5">
                      <b>Personal Message (optional)</b>
                    </div>

                    <div v-if="loadingAnimation" class="card-content valign-wrapper center-align">
                      <LoadingCircle/>
                    </div>

                    <div v-if="!loadingAnimation" class="card-content">
                      If you want us to include a personal message on the gift certificate, please write it here.<br>
                      <textarea
                        id="message"
                        v-model="orderMessage"
                        class="materialize-textarea"
                        placeholder="Enter your message here"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-action blue-grey lighten-5">
              <div class="right">
                <a
                  class="waves-effect waves-light grey darken-2 btn mr-3"
                  :disabled="loadingAnimation || saveInProgress"
                  @click="makePayment('offline')"
                >
                  Pay offline
                  <i v-if="!saveInProgress" class="material-icons right">keyboard_arrow_right</i>
                  <div v-if="saveInProgress" class="saving-animation">
                    <div class="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </a>

                <a
                  class="waves-effect waves-light btn green"
                  :disabled="loadingAnimation || saveInProgress"
                  @click="makePayment('online')"
                >
                  Make payment online
                  <i v-if="!saveInProgress" class="material-icons right">keyboard_arrow_right</i>
                  <div v-if="saveInProgress" class="saving-animation">
                    <div class="lds-ripple">
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </a>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import LoadingCircle from '@/components/lib/LoadingCircle'
// Import the API functions
import httpApi from '@/utils/api'

import numeral from 'numeral'

export default {
  components: {
    LoadingCircle
  },

  data () {
    return {
      redirectToGateway: false,
      offlinePayment: false,

      // Loading status
      loadingAnimation: true,

      // Subscription details setup
      subscriptionDetails: {
        planID: 0,
        planTitle: '',
        duration: '',
        rate: '',
        shippingRate: ''
      },

      orderMessage: '',
      couponCode: '',

      showCouponField: false,
      formErrorsCouponCode: '',
      discountAmount: 0,

      saveInProgress: false
    }
  },

  mounted () {
    if (this.subscribe.planID > 0) {
      // Get details of the selected plan
      this.getPlanDetails()
        .then(() => {
          // Get shipping rates from API
          this.getShippingRate()
            .then(() => {
              // Deactivate the loading animation
              this.loadingAnimation = false
            })
            .catch((err) => {
              this.errorList = err.message
            })
        })
        .catch((err) => {
          this.errorList = err.message
        })
    } else {
      // Go to subscription selection page
      this.$router.push('/subscribe')
    }
  },

  computed: {
    // Get vuex store data, to be used in this component
    ...mapGetters(['isGift', 'subscribe', 'isAuthenticated']),

    couponTitle () {
      if (this.discountAmount > 0) {
        return 'Coupon Discount: ' + this.couponCode
      } else {
        return 'Have a coupon?'
      }
    },

    planTotal () {
      return this.subscriptionDetails.rate * this.subscriptionDetails.duration
    },

    shippingTotal () {
      return this.subscriptionDetails.shippingRate * this.subscriptionDetails.duration
    },

    grandTotal () {
      return this.planTotal - this.discountAmount + this.shippingTotal
    }
  },

  methods: {
    formatAmount (val) {
      return numeral(val).format('0,0.00')
    },

    getPlanDetails () {
      // Promise a return
      return new Promise((resolve, reject) => {
        httpApi.callWithKey({
          url: 'plan?planID=' + this.subscribe.planID,
          method: 'get'
        })
          .then((resp) => {
            // Assign subscription plan details
            this.subscriptionDetails.planID = resp.data.id
            this.subscriptionDetails.planTitle = resp.data.title
            this.subscriptionDetails.duration = resp.data.duration
            this.subscriptionDetails.rate = resp.data.rate
            resolve()
          })
          // If an error occurs
          .catch((err) => {
            // Error
            reject(err)
          })
      })
    },

    getShippingRate () {
      // Promise a return
      return new Promise((resolve, reject) => {
        httpApi.callWithKey({
          url: 'shipping?locationID=' + this.subscribe.deliveryCity,
          method: 'get'
        })
          .then((resp) => {
            // Assign shipping rate
            this.subscriptionDetails.shippingRate = resp.data.shippingRate
            resolve()
          })
          // If an error occurs
          .catch((err) => {
            // Error
            reject(err)
          })
      })
    },

    validateCoupon () {
      this.couponCode = this.couponCode.toUpperCase()
      let params = ''
      params += '?couponCode=' + this.couponCode
      params += '&planID=' + this.subscribe.planID

      // Validate user entered coupon code
      httpApi.callWithKey({
        url: 'coupon' + params,
        method: 'get'
      })
        .then((resp) => {
          // Work out discount details
          let discountType = resp.data.discountType
          let discountAmount = resp.data.discountAmount
          this.formErrorsCouponCode = ''

          // Percentage discount
          if (discountType === '1') {
            this.discountAmount = this.planTotal * (discountAmount / 100)

          // Value discount
          } else {
            this.discountAmount = discountAmount
          }

          this.showCouponField = false
        })
        // If an error occurs
        .catch((err) => {
          // Error
          this.formErrorsCouponCode = err.message
        })
    },

    removeCoupon () {
      this.couponCode = ''
      this.discountAmount = 0
      this.formErrorsCouponCode = ''
      this.showCouponField = !this.showCouponField
    },

    changePlan () {
      if (this.isGift) {
        // Go to subscription selection page
        this.$router.push('/gift')
      } else {
        // Go to subscription selection page
        this.$router.push('/subscribe')
      }
    },

    makePayment (payMethod) {
      this.saveInProgress = true

      // If logged in and is not a gift, send userID, so invoice can be linked to user
      if (this.isAuthenticated && !this.isGift) {
        if (this.discountAmount <= 0) {
          this.couponCode = ''
        }
        let dataBody = {
          deliveryCity: this.subscribe.deliveryCity,
          city: this.subscribe.city,
          planID: this.subscribe.planID,
          couponCode: this.couponCode,
          orderMessage: this.orderMessage,
          payMethod: payMethod,
          isGift: this.isGift
        }

        // Save to API
        httpApi.callWithToken({
          url: 'subscription/start',
          data: dataBody,
          method: 'post'
        })
          .then((resp) => {
            if (payMethod === 'online') {
              // Show success message
              this.redirectToGateway = true

              setTimeout(() => {
                window.location = resp.data.payurl
              }, 1000)
            } else {
              // Show success message
              this.offlinePayment = true
            }
          })
          .catch((err) => {
            // Hide loading animation
            this.saveInProgress = false

            // Empty older errors
            this.formErrors = Object.assign({}, this.defaultFormErrors)

            // Show new errors. Timeout required, else fails
            setTimeout(() => {
              let errors = Object.keys(err.data)
              errors.forEach((value, key) => {
                // Set error message
                this.formErrors[value] = err.data[value]
              })
            }, 100)

            // There could be multiple errors in an array. Convert to a string
            let errorString = Object.values(err.data)
            errorString = errorString.join(', ')

            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: errorString
            })
          })
      } else {
        if (this.discountAmount <= 0) {
          this.couponCode = ''
        }
        let dataBody = {
          email: this.subscribe.email,
          name: this.subscribe.name,
          phone: this.subscribe.phone,
          toEmail: this.subscribe.toEmail,
          toName: this.subscribe.toName,
          toPhone: this.subscribe.toPhone,
          deliveryCity: this.subscribe.deliveryCity,
          city: this.subscribe.city,
          planID: this.subscribe.planID,
          couponCode: this.couponCode,
          orderMessage: this.orderMessage,
          payMethod: payMethod,
          isGift: this.isGift
        }

        // Save to API
        httpApi.callWithKey({
          url: 'subscription/start',
          data: dataBody,
          method: 'post'
        })
          .then((resp) => {
            if (payMethod === 'online') {
              // Show success message
              this.redirectToGateway = true

              setTimeout(() => {
                window.location = resp.data.payurl
              }, 1000)
            } else {
              // Show success message
              this.offlinePayment = true
            }
          })
          .catch((err) => {
            // Hide loading animation
            this.saveInProgress = false

            // Empty older errors
            this.formErrors = Object.assign({}, this.defaultFormErrors)

            // Show new errors. Timeout required, else fails
            setTimeout(() => {
              let errors = Object.keys(err.data)
              errors.forEach((value, key) => {
                // Set error message
                this.formErrors[value] = err.data[value]
              })
            }, 100)

            // There could be multiple errors in an array. Convert to a string
            let errorString = Object.values(err.data)
            errorString = errorString.join(', ')

            // Show error message
            this.$store.dispatch('SHOW_STATUS_MESSAGE', {
              color: 'error',
              message: errorString
            })
          })
      }
    }
  }
}
</script>
